import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Patch DOM methods to prevent browser extensions from crashing React.
// Extensions (Grammarly, translation tools, etc.) may remove DOM nodes that
// React still tracks, causing "removeChild: not a child of this node" errors.
const originalRemoveChild = Node.prototype.removeChild;
Node.prototype.removeChild = function <T extends Node>(child: T): T {
  if (child.parentNode !== this) {
    console.warn('[DOM patch] removeChild: node is not a child, skipping');
    return child;
  }
  return originalRemoveChild.call(this, child) as T;
};

const originalInsertBefore = Node.prototype.insertBefore;
Node.prototype.insertBefore = function <T extends Node>(newNode: T, refNode: Node | null): T {
  if (refNode && refNode.parentNode !== this) {
    console.warn('[DOM patch] insertBefore: refNode is not a child, appending');
    return originalInsertBefore.call(this, newNode, null) as T;
  }
  return originalInsertBefore.call(this, newNode, refNode) as T;
};

// Enable dark mode by default
document.documentElement.classList.add("dark");

createRoot(document.getElementById("root")!).render(<App />);
